var map = {
	"./ai.mp4": 3125,
	"./casualGames.mp4": 4807,
	"./finance.mp4": 7845,
	"./shortPlays.mp4": 9476,
	"./social.mp4": 4554,
	"./tools.mp4": 250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5580;